export default __webpack_public_path__ + "static/solutions-4-98a75e5d9cf34c022c90c0bde80e7f42.webp";